import React from 'react';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';
import './FieldInputFile.global.scss';
import edit from '../../assets/svg/edit.svg';

interface Props {
  rootClassName?: string,
  className?: string,
  id: any,
  name: string,
  formProps: any,
  disabled?: boolean,
  enableDrop?: boolean,
}

const FieldFileInput = (props: Props) => {
  const {
    rootClassName,
    className,
    id,
    name,
    formProps: { control },
    disabled,
    enableDrop,
  } = props;

  const classes = classNames(rootClassName || 'root', className ? [className] : null);
  const [_value, _setValue] = React.useState<any>('');
  const [file, setFile] = React.useState<any>('');
  const [dragging, setDragging] = React.useState(false);
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: {
          ref, onChange, value,
        },
      }) => {
        const applyFiles = (files: FileList) => {
          _setValue('');
          setFile(files[0]);
          onChange(files);
        };
        const dropHandlers = enableDrop && !disabled ? {
          onDragEnter: (e: React.DragEvent) => {
            e.preventDefault();
            setDragging(true);
          },
          onDragOver: (e: React.DragEvent) => {
            e.preventDefault();
            setDragging(true);
          },
          onDragLeave: (e: React.DragEvent) => {
            e.preventDefault();
            setDragging(false);
          },
          onDrop: (e: React.DragEvent) => {
            e.preventDefault();
            setDragging(false);
            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
              applyFiles(e.dataTransfer.files);
            }
          },
        } : {};
        return (
          <div className={classNames(classes, { drag: dragging })} {...dropHandlers}>
            <div className='file_s'>
              <div className='fileiconU'>
                <input
                  type="file"
                  id={id}
                  ref={ref}
                  onChange={(e: any) => {
                    if (e.target.files.length > 0) {
                      _setValue(e.target.value);
                      setFile(e.target.files[0]);
                      onChange(e.target.files);
                    }
                  }}
                  value={_value}
                  disabled={disabled}
                  title=""
                />
                <img src={edit} alt="userprofile" />
              </div>
            </div>
            <span className='fileimage'>
              {value !== null && value !== undefined && typeof (value) === 'string' && value !== '' && <img src={value} alt="upload" />}
              {value !== null && value !== undefined && typeof (value) === 'object' && <img src={URL.createObjectURL(file)} alt="upload" />}
            </span>
          </div>
        );
      }}
    />
  );
};

export default FieldFileInput;
